'use strict';
const Backbone = require('backbone');
const Moment = require('moment');
const DataSource = require('../../value/content/data-source');
const MetaData = require('../../value/content/meta-data');

module.exports = Backbone.Model.extend({
    defaults: {
        _content: null,
        name: '',
        dataSource: null,
        metaData: null,
        updatedAt: null,
        updatedBy: null
    },

    initialize: function() {
        this.set({_dataSource: new DataSource(this.get('dataSource'))});
        this.set({_metaData: new MetaData(this.get('metaData'))});
    },

    getContent: function() {
        return this.get('_content');
    },

    getName: function() {
        return this.get('name');
    },

    getDataSource: function() {
        return this.get('_dataSource');
    },

    getMetaData: function() {
        return this.get('_metaData');
    },

    prettySizeString: function() {
        const size = this.getMetaData().get('size');
        if(size > 1000 * 1000) {
            return Math.round(size / 100 / 1000) / 10 + 'MB';
        }
        if(size > 1000) {
            return Math.round(size / 100) / 10 + 'KB';
        }
        return size + 'B';
    },

    getUpdatedAt: function() {
        return Moment(this.get('updatedAt'));
    },

    getUpdatedBy: function() {
        return this.get('updatedBy');
    },

    delete: function() {
        this.set('deleted', true);
    },

    isDeleted: function() {
        return this.get('deleted');
    },

    isImage: function() {
        return this.getMetaData().isImage();
    },

    isXLS: function() {
        return this.getMetaData().isXLS();
    },

    isXMI: function() {
        return this.getMetaData().isXMI();
    },

    isPDF: function() {
        return this.getMetaData().isPDF();
    },

    isEmpty: function() {
        return this.getDataSource().isEmpty();
    }
});



// WEBPACK FOOTER //
// ./data/domain/entity/content/version.js